import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sugar-crm-dev',
  templateUrl: './sugar-crm-dev.component.html',
  styleUrls: ['./sugar-crm-dev.component.css']
})
export class SugarCrmDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/sugar-crm-dev/sugar-crm-dev.component.ts